import axios, { AxiosProgressEvent } from 'axios';

interface AuthenticatedUploadOptions {
  action: string;
  data?: Record<string, string | Blob>;
  file: File;
  filename: string;
  headers?: Record<string, string>;
  onProgress: (event: AxiosProgressEvent & { percent: number }) => void;
  withCredentials?: boolean;
}

interface AuthenticatedUploadRequest extends Promise<unknown> {
  abort: () => void;
}

const authenticatedUploadRequest = (options: AuthenticatedUploadOptions): AuthenticatedUploadRequest => {
  const data = new FormData();
  Object.entries(options.data || {}).forEach(([key, value]) => data.append(key, value));
  data.append(options.filename, options.file, options.file.name);

  const controller = new AbortController();
  const request = axios.post(options.action, data, {
    headers: options.headers,
    onUploadProgress: (event) => options.onProgress({
      ...event,
      percent: event.total ? (event.loaded / event.total) * 100 : 0,
    }),
    signal: controller.signal,
    withCredentials: options.withCredentials,
  }).then((response) => response.data) as AuthenticatedUploadRequest;
  request.abort = () => controller.abort();
  return request;
};

export default authenticatedUploadRequest;

